/* eslint-disable react/no-array-index-key */
import React from 'react';

import Box from '@mui/material/Box';

import { MediaTypes } from '@ts-core/utils/Constants';
import MediaPlayer from '@ts-core/modules/media/components/MediaPlayer';
import Image from '@ts-core/core/components/Image';

import { CoreExerciseMediaItem } from '../../types';

interface ExerciseMediaProps {
  media?: CoreExerciseMediaItem[];
  showNameWhenProcessing?: boolean;
}

const ExerciseMedia = (props: ExerciseMediaProps) => {
  const { media: mediaList, showNameWhenProcessing = false } = props;

  if (!mediaList) {
    return <span />;
  }

  function renderMediaItem(mediaItem: CoreExerciseMediaItem) {
    const { type } = mediaItem;
    switch (type) {
      case MediaTypes.Image:
        return <Image alt="ej" src={mediaItem.url} sx={{ maxWidth: '100%' }} />;
      case MediaTypes.Audio:
      case MediaTypes.Video:
        return <MediaPlayer media={mediaItem} showNameWhenProcessing={showNameWhenProcessing} />;
      default:
        return null;
    }
  }

  return (
    <>
      {mediaList?.map((media, i) => (
        <Box key={i} width="100%">
          {renderMediaItem(media)}
        </Box>
      ))}
    </>
  );
};

export default ExerciseMedia;
